import { type HierarchicalItem } from 'src/types/elements.type';
import {
  IResource,
  ResourceAdd,
  type ResourceAttachFile,
  type ResourceShort,
  type ResourceSort
} from 'src/types/master_data/resource.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/resources';

export const getResources = async (
  appInfoId?: number,
  isMenu?: boolean,
  isMobile?: boolean,
  sequenceStatus?: string
  // searchCondition?: string | undefined
) => {
  return await http.get<IResource[]>(`${controller}/get-by-app`, {
    params: { sequenceStatus, appInfoId, isMenu, isMobile }
  });
};

export const getResourcesByParent = async (appInfoId?: number, parentId?: number, isMenu?: boolean) => {
  return await http.get<ResourceShort[]>(`${controller}/get-by-parent`, {
    params: {
      appInfoId,
      parentId,
      isMenu
    }
  });
};

export const getResource = async (id: number) => {
  return http.get<IResource>(`${controller}/${id}`);
};

export const addResource = async (resource: ResourceAdd) => {
  return http.post<ResourceAdd>(controller, resource);
};

export const updateResource = async (id: number, resource: IResource) => {
  return await http.put(`${controller}/${id}`, resource);
};

export const deleteResource = async (id: number) => {
  await http.delete(`${controller}/${id}`);
};

export const sortResources = async (sorts: ResourceSort[]) => {
  return await http.put(`${controller}/sort`, sorts);
};

export const getResourcesDropdown = async (appInfoId?: number, isMenu?: boolean) => {
  return http.get<HierarchicalItem[]>(`${controller}/dropdown`, {
    params: {
      appInfoId,
      isMenu
    }
  });
};

export const uploadResourceFile = async (formData: FormData) => {
  return await http.post<ResourceAttachFile[]>(`${controller}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getResourceFile = async (filePath: string) => {
  return await http.get(`${controller}/get-file`, {
    params: {
      fileUrl: filePath
    },
    responseType: 'blob'
  });
};
